import { type FC } from "react";
import type { PlainLLMUsageSummary } from "@/queries/ona-intelligence-queries";
import { Card } from "@/components/podkit/Card";
import { Text } from "@/components/podkit/typography/Text";

type Period = "week" | "month" | "year";

type Props = {
    summary: PlainLLMUsageSummary;
    period: Period;
};

const periodDays: Record<Period, number> = {
    week: 7,
    month: 30,
    year: 365,
};

export const UsageSummaryCards: FC<Props> = ({ summary, period }) => {
    const totalCredits = summary?.creditsConsumed ?? 0;
    const daysInPeriod = periodDays[period];
    const averagePerDay = daysInPeriod > 0 ? totalCredits / daysInPeriod : 0;

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <Card className="p-4">
                <div className="flex flex-col gap-2">
                    <Text className="text-sm text-content-secondary">Total Credits Consumed</Text>
                    <Text className="text-3xl font-semibold text-content-primary">
                        {totalCredits.toLocaleString(undefined, {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        })}
                    </Text>
                    <Text className="text-xs text-content-tertiary">credits</Text>
                </div>
            </Card>

            <Card className="p-4">
                <div className="flex flex-col gap-2">
                    <Text className="text-sm text-content-secondary">Average Per Day</Text>
                    <Text className="text-3xl font-semibold text-content-primary">
                        {averagePerDay.toLocaleString(undefined, {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        })}
                    </Text>
                    <Text className="text-xs text-content-tertiary">credits/day</Text>
                </div>
            </Card>
        </div>
    );
};
